import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {
  clearConfiguration, downloadConfigurationPdf,
  fetchConfiguration,
} from "../../../store/reducers/configurationSlice";
import ErrorMessage from "../../Shared/ErrorMessage";
import {fetchProject} from "../../../store/reducers/projectSlice";
import {
  Container,
  ContentCard,
  Title,
  InfoRow,
  Label,
  Value,
  ButtonContainer,
  Button,
  BackLink,
  NotFound
} from "./styled";
// import JsonView from "../../Shared/JsonView";
import LoadingScreen from "../../Shared/LoadingScreen";
import ConfigurationInputs from "./ConfigurationInputs";

const ConfigurationDetails = () => {
  const { configurationId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const configuration = useSelector(state => state.configuration.currentConfiguration);
  const project = useSelector(state => state.project.currentProject);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const onErrorClick = () => {
    dispatch(clearConfiguration())
    navigate("/configurations/basic")
  }

  function onDownloadReportPdf() {
    dispatch(downloadConfigurationPdf(configurationId))
      .unwrap()
      .then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((error) => console.error('Download failed', error));
  }

  function onDownloadInputs() {
    try {
      const jsonString = JSON.stringify(configuration.input, null, 2);
      const blob = new Blob([jsonString], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `configuration-inputs-${configuration.configurationId || 'unknown'}.json`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed', error);
    }
  }

  useEffect(() => {
    dispatch(fetchConfiguration(configurationId))
      .unwrap()
      .then(data => {
        dispatch(fetchProject(data.projectId));
      })
      .catch(error => {
        console.error('Error:', error);
        setError(error);
      })
      .finally(() => setLoading(false));
  }, [configurationId, dispatch]);

  if (loading) {
    return <LoadingScreen message="Loading Configuration" submessage="Fetching configuration details" />;
  }

  if (error) return (
    <NotFound>
      {error && <ErrorMessage message={error} />}
      <Button onClick={onErrorClick}>Create new configuration</Button>
    </NotFound>
  );

  return (
    <Container>
      <BackLink href={"/projects/" + project?.projectId}>
        Back to project
      </BackLink>
      
      <ContentCard>
        <Title>Configuration Details #{configuration.projectConfigurationId}</Title>
        
        <InfoRow>
          <Label>Name:</Label> <Value>{configuration.name}</Value>
        </InfoRow>
        
        <InfoRow>
          <Label>Project Configuration #:</Label> <Value>{configuration.projectConfigurationId}</Value>
        </InfoRow>
        
        <InfoRow>
          <Label>User Configuration #:</Label> <Value>{configuration.configurationId}</Value>
        </InfoRow>
        
        <InfoRow style={{ marginBottom: '4px' }}>
          <Label>Configuration Inputs:</Label>
        </InfoRow>
        
        {/* <JsonContainer>
          <JsonView jsonData={configuration.input}/>
        </JsonContainer> */}
        
        <ConfigurationInputs 
          input={configuration.input} 
          fusionMachineType={project?.fusionMachineType}
        />
        
        <ButtonContainer>
          {/* {configuration.hasReportTex && (
            <Button onClick={onDownloadReportTex}>Download Report TEX</Button>
          )} */}
          {configuration.hasReportPdf && (
            <Button onClick={onDownloadReportPdf}>Download Report PDF</Button>
          )}
          <Button onClick={onDownloadInputs}>Download Inputs</Button>
        </ButtonContainer>
      </ContentCard>
    </Container>
  )
};

export default ConfigurationDetails;